import { render, staticRenderFns } from "./IconCaretLeft.vue?vue&type=template&id=0192c477&scoped=true&"
import script from "./IconCaretLeft.vue?vue&type=script&lang=js&"
export * from "./IconCaretLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../dates/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0192c477",
  null
  
)

export default component.exports